import { render, staticRenderFns } from "./ListTotauxLivraisons.vue?vue&type=template&id=420fdde1&"
import script from "./ListTotauxLivraisons.vue?vue&type=script&lang=ts&"
export * from "./ListTotauxLivraisons.vue?vue&type=script&lang=ts&"
import style0 from "./ListTotauxLivraisons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports